import { DashboardPeriodPreset, IVisitPeriod } from "../types/ownerDashboard.types";
import { getAllTimePeriod } from "./getAllTimePeriod";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";

export interface KenloPaymentsQuery {
  chartPeriod: DashboardPeriodPreset;
  chartCustomRange?: IVisitPeriod;
  chartZoom?: number | "all";
  paymentsPeriod: IVisitPeriod;
  propertyId?: number | null;
  kenloPropertyId?: string | null;
  historyYears?: number;
  paymentsPage?: number;
  paymentsPerPage?: number;
}

export function buildKenloPaymentsParams(
  query: KenloPaymentsQuery
): Record<string, string> {
  const params: Record<string, string> = {
    initial_date: query.paymentsPeriod.initial_date,
    final_date: query.paymentsPeriod.final_date,
  };

  if (query.chartCustomRange) {
    params.chart_initial_date = query.chartCustomRange.initial_date;
    params.chart_final_date = query.chartCustomRange.final_date;
  } else if (query.chartPeriod === "all_time") {
    const allTimeRange = getAllTimePeriod(new Date(), query.historyYears);
    params.chart_initial_date = allTimeRange.initial_date;
    params.chart_final_date = allTimeRange.final_date;
  } else {
    params.period = query.chartPeriod;
  }

  if (query.propertyId != null) {
    params.property_id = String(query.propertyId);
  } else if (query.kenloPropertyId) {
    params.kenlo_property_id = normalizeKenloPropertyId(query.kenloPropertyId);
  }

  if (query.paymentsPage != null) {
    params.page = String(query.paymentsPage);
  }

  if (query.paymentsPerPage != null) {
    params.per_page = String(query.paymentsPerPage);
  }

  return params;
}
